module.exports = __webpack_public_path__ + "static/img/19.39f7d6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/19.png
// module id = V158
// module chunks = 0